import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateCountyComponent = loadable(
  () => import("../../components/Country/CreateCountry")
);
const CreateCountry = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["country"],
    navigateURL: "/country",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}`;
    let formData = {
      ...values,
      parent: null,
      group: values.group?.map((item: any) => item.value),
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Country
        </span>
      </div>
      <CreateCountyComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateCountry;
